<template>
  <div v-if="isLoaded">
    <div
      class="content-body"
      v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card" style="">
            <div class="card-header">
              <h4 class="card-title">Tipo de Carga</h4>
              <a class="heading-elements-toggle"
                ><i
                  class="fa fa-ellipsis-v font-medium-3"
                  @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"
                ></i
              ></a>
              <div
                class="heading-elements"
                v-bind:class="{
                  visible: getSubMenuShowHideFw(),
                  '': !getSubMenuShowHideFw(),
                }"
              >
                <ul class="list-inline mb-0">
                  <li>
                    <a
                      @click="onCreate()"
                      v-b-tooltip
                      title="Cadastrar"
                      v-if="getPermissionFw('percursouf.store')"
                      ><i class="fa fa-plus"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterReset()"
                      v-b-tooltip
                      title="Atualizar listagem"
                      ><i class="ft-rotate-cw"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreenFw()"
                      v-b-tooltip
                      title="Expande a tela"
                      v-if="!isFullscreen"
                      ><i class="ft-maximize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreenFw()"
                      v-b-tooltip
                      title="Minimiza a tela"
                      v-if="isFullscreen"
                      ><i class="ft-minimize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterShowHideFw()"
                      v-b-tooltip.hover.left="'Filtros'"
                      ><i class="fa fa-filter"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onActivateDesactivate(1, null, false)"
                      v-b-tooltip
                      title="Ativar Registros"
                      v-if="getPermissionFw('percursouf.status')"
                      ><i class="fa fa-thumbs-o-up"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onActivateDesactivate(2, null, false)"
                      v-b-tooltip
                      title="Inutilizar Registros"
                      v-if="getPermissionFw('percursouf.status')"
                      ><i class="fa fa-thumbs-o-down"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table-responsive">
                <div v-if="vuetableFilterRow">
                  <vuetable-filterbar> </vuetable-filterbar>
                </div>
                <div class="loadingDataPosition">
                  <div class="loadingData" v-if="loadingData">
                    <div class="loadingDataSpinner">
                      <spinner
                        v-if="loadingData"
                        text-fg-color="#ffffff"
                        message="Carregando..."
                      ></spinner>
                    </div>
                  </div>
                  <vuetable
                    ref="vuetable"
                    api-url="/api/tipocarga"
                    :fields="fields"
                    :css="css"
                    :append-params="moreParams"
                    track-by="tpcarga_id"
                    pagination-path=""
                    @vuetable:load-error="onError"
                    detail-row-component="percursouf-detalhes"
                    @vuetable:cell-clicked="onDetail"
                    @vuetable:pagination-data="onPaginationData"
                    @vuetable:loaded="onLoaded"
                  >
                    <template slot="status" slot-scope="props">
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.status.valor == 1"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.status.valor == 2"
                        >{{ props.rowData.status.descr }}</span
                      >
                    </template>
                    <template slot="cnpj_cpf_origem" slot-scope="props">
                      <span
                        >{{ ajustaMascara(props.rowData.cnpj_cpf_origem) }}</span
                      >
                    </template>
                    <template slot="cnpj_cpf_destino" slot-scope="props">
                      <span
                        >{{ ajustaMascara(props.rowData.cnpj_cpf_destino) }}</span
                      >
                    </template>
                    <template slot="cnpj_cpf_redespacho" slot-scope="props">
                      <span
                        >{{ ajustaMascara(props.rowData.cnpj_cpf_redespacho) }}</span
                      >
                    </template>

                    <template slot="actions" slot-scope="props">
                      <div class="custom-actions">
                        <span v-if="getPermissionFw('permission.status')">
                          <a
                            @click="onEdit(props.rowData)"
                            v-b-tooltip
                            title="Editar"
                            ><i class="fa fa-edit"></i
                          ></a>
                          <a
                            v-if="props.rowData.status.valor == 2"
                            @click="
                              onActivateDesactivate(1, props.rowData, true)
                            "
                            v-b-tooltip
                            title="Ativar"
                            ><i class="fa fa-thumbs-o-up"></i
                          ></a>
                          <a
                            v-if="props.rowData.status.valor == 1"
                            @click="
                              onActivateDesactivate(2, props.rowData, true)
                            "
                            v-b-tooltip
                            title="Inativar"
                            ><i class="fa fa-thumbs-o-down"></i
                          ></a>
                          <!-- <a
                            @click="onDetail(props.rowData, null, null)"
                            v-b-tooltip
                            title="Ver detalhes"
                            ><i class="fa fa-plus"></i
                          ></a> -->
                        </span>
                      </div>
                    </template>
                  </vuetable>
                </div>
                <div>
                  <div class="col-md-12">
                    <div class="pull-left pagination-detail">
                      <vuetable-pagination-info
                        ref="paginationInfo"
                        :css="css.pagination"
                        info-class="pull-left"
                      ></vuetable-pagination-info>
                    </div>
                    <div class="pull-right m-a-0">
                      <vuetable-pagination
                        ref="pagination"
                        :css="css.pagination"
                        @vuetable-pagination:change-page="onChangePage"
                      ></vuetable-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <TipoCargaForm ref="tipocargaform" :metodo="onFilterReset">
      </TipoCargaForm>
    </div>
  </div>
</template>
<script>
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import TipoCargaFilterBar from "./TipoCargaFilterBar";
import TipoCargaForm from "./TipoCargaForm";
import percursoufDetalhes from "./PercursoUfDetalhes";

Vue.component("percursouf-detalhes", percursoufDetalhes);

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    TipoCargaForm,
    "vuetable-filterbar": TipoCargaFilterBar,
  },
  data() {
    return {
      dataExport: [],
      optionsLivStatus: [],
      optionsUnidade: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      form: new Form({ cd: "", descr: "", peruf_id: "", status: [] }),
      helpForm: new Form({ statusRecord: [], params: [] }),
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "unidade.descr",
          title: "Unidade",
        },
        {
          name: "descr",
          title: "Tipo de Carga",
        },
        {
          name: "__slot:cnpj_cpf_origem",
          title: "CPF/ CNPJ Origem",
        },
        {
          name: "__slot:cnpj_cpf_destino",
          title: "CPF/ CNPJ Destino",
        },
        {
          name: "__slot:cnpj_cpf_redespacho",
          title: "CPF/ CNPJ Redespacho",
        },
        {
          name: "__slot:status",
          title: "Status",
        },
        {
          name: "__slot:actions",
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
      ],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  mounted() {
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", (e) => this.onFilterReset());
    this.getLivGeral();
  },
  methods: {
    onDetail(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.peruf_id);
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onFilterSet(data_filter) {
      this.loadingData = true;
      this.moreParams = {
        unidade: data_filter.unidade.value,
        tipo_carga: data_filter.tipo_carga,
        destino: data_filter.destino,
        origem: data_filter.origem,
        resdespacho: data_filter.resdespacho,
        status: data_filter.status.value,
      };
      Vue.nextTick(() => {
        this.$refs.vuetable.refresh();
      });
    },
    getLivGeral() {
      this.helpForm
        .get("/api/tipocarga/jsonlist")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.status.forEach((obj) => {
            this.optionsLivStatus.push({
              text: obj.descr,
              label: obj.descr,
              value: obj.valor,
            });
          });
          response.unidade.forEach((obj) => {
            this.optionsUnidade.push({
              text: obj.cd + " - " + obj.descr,
              label: obj.descr,
              value: obj.unidade_id,
            });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    ajustaMascara(data) {
      if (data != null) {
        if (data.length == 11) {
          //cpf
          return data.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
        }
        if (data.length == 14) {
          //cnpj
          return data.replace(
            /([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})/,
            "$1.$2.$3/$4-$5"
          );
        }
      }
    },
    onFilterReset() {
      this.loadingData = true;
      this.moreParams = {};
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onLoaded: function () {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      this.$store.commit("setVuetableFilterButton", false);
    },
    onCreate() {
      this.$refs.tipocargaform.onCreate();
    },
    onEdit(data) {
      this.$refs.tipocargaform.onEdit(data);
    },
    onActivateDesactivate(action, data, tipo) {
      // Tipo = true = Checkbox
      if (tipo) {
        this.helpForm.statusRecord = [];
        this.helpForm.statusRecord.push({
          id: data.tpcarga_id,
          status: action,
        });
      } else {
        this.helpForm.statusRecord = [];
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.helpForm.statusRecord.push({ id: obj, status: action });
        });
      }
      this.$refs.tipocargaform.onActivateDesactivate(this.helpForm);
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
    isFullscreen: {
      get() {
        return this.$store.getters.is_full_screen;
      },
    },
  },
};
</script>
